import * as appStore from "./action-type";
import renameActionType from "Store/renameActionType";
// import Avatar from "Assets/images/userLogo.png";
import { setStore } from "Pub/js/storageUtils";
renameActionType(appStore, "appStore");

let defaultState = {
    lang: "zh-CN",
    intlDone: false,
    avatar: '',
    isOpen: false, // 账号设置侧拉是否打开
    allAppsOpen: false, // 全部应用侧拉是否打开
    userId: "",
    isAccountSettingSpr: false, // 是否为个人中心触发
    backgroundState: {}, //背景设置
    userCode: "", //用户编码
    userName: "用户名称",
    email: "", // 邮箱
    phone: '',//用户手机号
    currentData: [], // 所属集团数组
    businessDate: "", // 业务日期
    nccFont: { // 字体
        // fontSize,
        // fontValue
    },
    groupId: "", // 组织id
    groupName: "", // 组织名称
    projectCode: "", //项目编码
    nlinkUrl: "", // PE服务地址
    needBind: false, //是否需要绑定云账号 (false 不需要显示云注册弹窗.)
    isRealAuth: false, // true false
    is_cloud_register: false, //是否云注册用户 (false 不需要单点登录,不需要显示小铃铛.)
    messageData: {}, //消息数据
    knowledgeData: {}, //知识数据
    knowledgeRule: true, //知识权限
    recentData: [],//最近访问
    knowledgeReqRule: false,//知识管理请求权限
    disturbInfo: {},//勿扰模式
    errorFlag: false, // 错误中心标志
    newMsg: {},
    isCaLogin: false, //ca用户登录标记
    themeColor: null, //主题色
    breadCrumbClick: false, //是否点击面包屑
    theme: null, // 主题 { key: '', name: '', color: '' }
    workbenchData: [], // 工作台数据
    workbenchId: '', // queryworkbench查询返回的工作台主键,可能和workbenchData当前选中的不一样
    linkageData: [], // 联动设置数据
    deployType: '', //云类型 cloud 公有云  private 私有云
    watermarkInfo: { // 水印信息
        enable: false, // 是否启用
        config: {} // 配置项
        // enableApps: [] // 启用范围
    }
};
// 首页表单数据
export const appData = (state = defaultState, action = {}) => {
    switch (action.type) {
        case appStore.INITAPPDATA:
            return { ...state, ...action.value };
        case appStore.CHANGELANG:
            return { ...state, ...{ intlDone: action.value } };
        case appStore.DRAWEROPEN:
            return { ...state, ...{ isOpen: action.value } };
        case appStore.ALLAPPSDRAWEROPEN:
            return { ...state, ...{ allAppsOpen: action.value } };
        case appStore.ACCOUNTINFO:
            return { ...state, ...action.value };
        case appStore.AVATAREDIT:
            return { ...state, ...{ avatar: action.value } };
        case appStore.EMAIL:
            return { ...state, ...{ email: action.value } };
        case appStore.PHONE:
            return { ...state, ...{ phone: action.value } };
        case appStore.ACCOUNTACTIVATION:
            return {
                ...state,
                ...{ is_cloud_register: true, needBind: false }
            };
        case appStore.SETMESSAGEDATA:
            return { ...state, ...{ messageData: action.data } };
        case appStore.SETKNOWLEDGE:
            return { ...state, ...{ knowledgeData: action.data } };
        case appStore.SETKNOWLEDGERULE:
            return { ...state, ...{ knowledgeRule: action.data } };
        case appStore.SETRECENT:
            return { ...state, ...{ recentData: action.data } };
        case appStore.SETKNOWLEDGERULEONCE:
            return { ...state, ...{ knowledgeReqRule: action.data } };
        case appStore.SETDISTURBMODE:
            return { ...state, ...{ disturbInfo: action.data } };
        case appStore.ERROR:
            return { ...state, ...{ errorFlag: action.value } };
        case appStore.SETNEWMSG:
            return { ...state, ...{ newMsg: action.data } };
        case appStore.ISACCOUNTSETTINGSPR:
            return { ...state, ...{ isAccountSettingSpr: action.data } };
        case appStore.SETBACKGROUNDSTATE:
            return { ...state, ...{ backgroundState: action.data } };
        case appStore.NCCFONT:
            return { ...state, ...{ nccFont: action.data } };
        case appStore.SETTHEMECOLOR:
            const theme = action.themeColor;
            setStore('nccTheme', theme);
            return { ...state, ...{ themeColor: theme.type, theme } };
        case appStore.BREADCRUMBCLICK:
            return { ...state, ...{ breadCrumbClick: action.breadCrumbClick } };
        case appStore.SETWORKBENCHDATA:
            return { ...state, ...{ workbenchData: action.workbenchData } };
        case appStore.SETWORKBENCHID:
            return { ...state, ...{ workbenchId: action.workbenchId } };
        case appStore.SETLINKAGEDATA:
            return { ...state, ...{ linkageData: action.linkageData } };
        case appStore.SETWATERMARKINFO:
            return { ...state, ...{ watermarkInfo: action.watermarkInfo } };
        default:
            return state;
    }
};
